import { Paper, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import { ReactSortable } from "react-sortablejs";
import { getColumnColor } from "../utilities/color";

interface IProps {
	reset: boolean;
	data: any[];
	setData: (data: any[], key: string) => void;
	className?: string;
	columnKey: string;
	onBottom: (page: number) => void;
	children: any;
	index: number;
}

const ColumnDynamic = (props: IProps) => {
	const theme = useTheme();
	const [page, setPage] = useState<number>(1);

	const onBottom = () => {
		setPage(page + 1);
		props.onBottom(page + 1);
	};

	const scrollRef = useBottomScrollListener<HTMLDivElement>(onBottom);

	useEffect(() => {
		setPage(1);
		props.onBottom(1);
	}, [props.reset]);

	return (
		<div className={props.className ?? "min-w-[300px]"}>
			<Paper
				sx={{ background: getColumnColor(props.index)}}
				className="py-1 mb-3"
			>
				<Typography className="text-white text-center">
					{props.columnKey}
				</Typography>
			</Paper>
			<div
				ref={scrollRef}
				style={{ minHeight: "10vh", maxHeight: "70vh", overflowY: "auto" }}
			>
				<ReactSortable
					list={props.data}
					setList={(data) => {
						props.setData(data, props.columnKey);
					}}
					group="kanban"
					multiDrag
					swap
				>
					{props.children}
				</ReactSortable>
			</div>
		</div>
	);
};

export default ColumnDynamic;
